<template>
  <div style="background: #fcfcfc; padding-top: 19px; padding-bottom: 48px">
    <div class="release" v-loading="loading">
      <p class="releaseNap">
		  <!-- 当前位置：设计市场>发布需求 -->
		  <span>当前位置：</span>
		  <el-breadcrumb separator=">">
		    <el-breadcrumb-item :to="{ path: '/design' }">设计市场</el-breadcrumb-item>
		    <el-breadcrumb-item>发布需求</el-breadcrumb-item>
		  </el-breadcrumb>
		  </p>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="10px"
        class="demo-ruleForm"
      >
        <div class="releaseBox">
          <div class="releaseBoxTop">
            <h4>需求发布</h4>
            <div class="releaseBoxTopInput flex">
              <p class="releaseBoxbotInputP">需求类型：</p>
              <el-form-item prop="demandType" ref="demandType">
                <button
                  :class="releaseIndex == index ? 'releaseBut' : ''"
                  v-for="(items, index) in releaseButton"
                  :key="index"
                  @click="designRelease(index)"
                  type="button"
                >
                  {{ items.button }}
                </button>
              </el-form-item>
            </div>
            <div class="releaseBoxTopInput flex">
              <p class="releaseBoxbotInputP">需求名称：</p>
              <el-form-item prop="demandName" ref="demandName">
                <el-input
                  type="text"
                  style="width: 350px"
                  v-model="form.demandName"
                ></el-input>
              </el-form-item>
            </div>
            <div class="releaseBoxTopInput flex">
              <p class="releaseBoxbotInputP">需求预算：</p>
              <div class="flex" style="align-items: center">
                <el-form-item prop="lowPreAmount" ref="lowPreAmount">
                  <el-input
                    type="number"
                    class="input2"
                    placeholder="输入最低预算"
                    v-model="form.lowPreAmount"
                  ></el-input>
                </el-form-item>
                <span style="margin: 0px 3px 20px 12px">-</span>
                <el-form-item prop="highPreAmount" ref="highPreAmount">
                  <el-input
                    type="number"
                    class=""
                    placeholder="输入最高预算"
                    v-model="form.highPreAmount"
                  ></el-input>
                </el-form-item>
                <span style="margin: 0px 3px 20px 12px">元</span>
              </div>
            </div>

            <div class="releaseBoxTopInput flex">
              <p class="releaseBoxbotInputP">报价截止日期：</p>
              <el-form-item prop="deadline" ref="deadline">
                <el-date-picker
                  :clearable="false"
                  v-model="form.deadline"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="releaseBoxTopInput flex">
              <p class="releaseBoxbotInputP">期望交期：</p>
              <el-form-item
                prop="expectedDeliveryTime"
                ref="expectedDeliveryTime"
              >
                <el-date-picker
                  :clearable="false"
                  v-model="form.expectedDeliveryTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="releaseBoxTop">
            <h4>需求详情</h4>
            <div class="releaseBoxTopInput flex">
              <p class="releaseBoxbotInputP">{{ twoNameRelease }}</p>
              <el-form-item prop="demandClassId" ref="demandClassId">
                <button
                  :class="releaseIndexTwo == index ? 'releaseBut' : ''"
                  v-for="(items, index) in releaseButtonTwo[releaseIndex]"
                  :key="index"
                  @click="designReleaseTwo(items.code, index)"
                  type="button"
                >
                  {{ items.name }}
                </button>
              </el-form-item>
            </div>
            <div
              class="releaseBoxTopInput flex"
              style="align-items: flex-start"
            >
              <p class="releaseBoxbotInputP" style="padding-top: 5px">
                交付文件类型
              </p>
              <div class="flex releaseBoxTopInputBox">
                <el-form-item prop="fType" ref="fType">
                  <button
                    v-for="(items, index) in releaseButton2[releaseIndex]"
                    :class="{ releaseBut: arrIndex.indexOf(index) > -1 }"
                    :key="index"
                    @click="designRelease2(index)"
                    style="margin-bottom: 10px"
                    type="button"
                  >
                    {{ items.button }}
                  </button>
                  <button
                    :class="otherInput == true ? 'releaseBut' : ''"
                    @click="designReleaseOther()"
                    type="button"
                  >
                    其他
                  </button>
                  <input
                    type="text"
                    style="width: 100px"
                    placeholder="输入类型"
                    v-show="otherInput"
                    v-model="otherType"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="releaseBoxTopInput flex" v-if="releasShow">
              <p class="releaseBoxbotInputP">尺寸规格</p>
              <el-form-item
                prop="specificationsStart"
                ref="specificationsStart"
              >
                <el-input
                  type="text"
                  style="width: 160px; margin-right: 5px"
                  v-model="form.specificationsStart"
                ></el-input>
              </el-form-item>
              <el-form-item prop="specificationsEnd" ref="specificationsEnd">
                <span style="margin: 0px 3px 20px 12px">-</span>

                <el-input
                  type="text"
                  style="width: 160px; margin-left: 5px"
                  v-model="form.specificationsEnd"
                ></el-input>
              </el-form-item>

              <span style="margin: 0px 3px 20px 12px">cm</span>
            </div>
            <div
              class="releaseBoxTopInput flex"
              style="align-items: flex-start"
            >
              <p class="releaseBoxbotInputP">需求描述</p>
              <el-form-item
                prop="demandDes"
                style="width: 100%"
                ref="demandDes"
              >
                <el-input
                  v-model="form.demandDes"
                  type="textarea"
                  rows="10"
                ></el-input>
              </el-form-item>
            </div>
            <div
              class="releaseBoxTopInput flex"
              style="align-items: flex-start"
            >
              <p class="releaseBoxbotInputP">需求详情</p>
              <el-form-item prop="remark" ref="remark">
                <vue-editor
                  v-model="form.remark"
                  useCustomImageHandler
                  @image-added="handleImageAdded"
                  style="width: 100%"
                  class="vueql-editor"
                />
              </el-form-item>
            </div>
            <div class="releaseBoxTopInput flex">
            <p class="releaseBoxbotInputP">SEO关键字：</p>
            <el-form-item prop="metaKeywords">
              <el-input
                      type="textarea"
                      v-model="form.metaKeywords"
                      maxlength="50"
                      show-word-limit
                      style="width: 350px"
              ></el-input>
            </el-form-item>
          </div>

            <div class="releaseBoxTopInput flex">
              <p class="releaseBoxbotInputP">SEO描述：</p>
              <el-form-item prop="metaDescription">
                <el-input
                        type="textarea"
                        v-model="form.metaDescription"
                        maxlength="70"
                        show-word-limit
                        style="width: 350px"
                ></el-input>
              </el-form-item>
            </div>
            <div
              class="releaseBoxTopInput flex"
              style="align-items: flex-start"
            >
              <p class="releaseBoxbotInputP">文件上传</p>
              <el-upload
                class="upload-demo"
                action="/service-center/upload/file/single"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-success="handleAvatarSuccess"
                multiple
                :headers="headers"
                :file-list="fileList"
              >
                <el-button size="small" class="releaseBut">上传附件</el-button>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
            <div class="releaseBoxTopInput flex">
              <p class="releaseBoxbotInputP">交易方式预设</p>
              <button
                :class="releaseIndex3 == index ? 'releaseBut' : ''"
                v-for="(items, index) in releaseButton3"
                :key="index"
                @click="designRelease3(index)"
                type="button"
              >
                {{ items.button }}
              </button>
            </div>
          </div>
          <div class="releaseBoxBottom">
            <el-button type="text" @click="open">发布需求</el-button>
            <el-button :plain="true" @click="open2">保存需求</el-button>
            <el-button type="text" @click="open3">返回</el-button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { addDemand, getDictionaryItem, single } from "../../utils/interface";
import { mapState } from "vuex";

export default {
  //   发布需求
  name: "designRelease",
  data() {
    return {
      form: {
        demandType: "",
        demandName: "",
        lowPreAmount: "",
        highPreAmount: "",
        deadline: "",
        expectedDeliveryTime: "",
        demandClassId: "",
        fType: [],
        specificationsStart: "",
        specificationsEnd: "",
        demandDes: "",
        metaKeywords: "",
        metaDescription: "",
      },
      rules: {
        demandType: [
          { required: true, message: "请选择需求类型", trigger: "change" },
        ],
        demandName: [
          { required: true, message: "请填写需求名称", trigger: "blur" },
        ],
        lowPreAmount: [
          { required: true, message: "请填写预算最小值", trigger: "blur" },
        ],
        highPreAmount: [
          { required: true, message: "请填写预算最大值", trigger: "blur" },
          {
            required: true,
            validator: this.preAmount,
            trigger: "blur",
          },
        ],
        deadline: [
          { required: true, message: "请选择报价截止日期", trigger: "change" },
        ],
        expectedDeliveryTime: [
          { required: true, message: "请选择期望交期", trigger: "change" },
          {
            required: true,
            validator: this.deadDate,
            trigger: "change",
          },
        ],
        demandClassId: [
          { required: true, message: "请选择需求分类", trigger: "change" },
        ],
        fType: [
          { required: true, message: "请选择交付文件类型", trigger: "change" },
        ],
        specificationsStart: [
          { required: true, message: "请填写尺寸规格最小值", trigger: "blur" },
        ],
        specificationsEnd: [
          { required: true, message: "请填写尺寸规格最大值", trigger: "blur" },
          {
            required: true,
            validator: this.specifications,
            trigger: "blur",
          },
        ],
        demandDes: [
          { required: true, message: "请填写需求描述", trigger: "blur" },
        ],
        metaKeywords:[
          {max: 50, message: '最多允许输入50个汉字'}
        ],
        metaDescription:[
          {max: 70, message: '最多允许输入70个汉字'}
        ]
      },
      priceShow1: false,
      priceShow2: false,
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
      },
      loading: false,
      setIn: null, // 定时器
      radio: "1",
      releaseButton: [
        {
          button: "",
        },
        {
          button: "",
        },
      ],
      releaseIndex: "0",
      releaseButtonTwo: [],
      releaseIndexTwo: null,
      releaseButton2: [
        [
          {
            button: "STEP",
          },
          {
            button: "STL",
          },
          {
            button: "IGES",
          },
          {
            button: "OBJ",
          },
        ],
        [
          {
            button: "BMP",
          },
          {
            button: "JPG",
          },
          {
            button: "PNG",
          },
          {
            button: "CDR",
          },
          {
            button: "PCD",
          },
          {
            button: "AI",
          },
          {
            button: "RAW",
          },
          {
            button: "WMF",
          },
        ],
      ],
      releaseIndex2: "0",

      releaseButton3: [
        {
          button: "线上支付",
          payType: "ONLINE",
        },
        // {
        //   button: "线下支付",
        // },
      ],
      releaseIndex3: "0",
      //   交期
      value1: "",
      //   文件上传
      fileList: [],
      releasShow: true,
      arrIndex: [],
      dialogImageUrl: "",
      dialogVisible: false,
      twoNameRelease: "",
      otherInput: false,
      //   区间金额
      monyeOne: "",
      monyeTwo: "",
      //   区间尺寸
      specificationsStart: "",
      specificationsEnd: "",
      fType: [],
      otherType: "",
      agreePrice: "",
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
    }),
  },
  created() {
    if (!this.isLogin) {
      this.$router.push("/login");
    }
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        this.getDictionaryItem();
      }
    }, 500);
  },
  mounted() {
    this.initTitle();
  },
  methods: {
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // console.log('图片上传', );
      var formData = new FormData();
      formData.append("file", file); //第一个file 后台接收的参数名
      let res = await single(formData);
      // console.log('上传成功', res);
      if (res.url) {
        Editor.insertEmbed(cursorLocation, "image", res.url);
        resetUploader();
      } else {
        alert("上传返回失败");
      }
    },
    // 富文本
    initTitle() {
      // toolbar标题
      const titleConfig = [
        { Choice: ".ql-insertMetric", title: "跳转配置" },
        { Choice: ".ql-bold", title: "加粗" },
        { Choice: ".ql-italic", title: "斜体" },
        { Choice: ".ql-underline", title: "下划线" },
        { Choice: ".ql-header", title: "段落格式" },
        { Choice: ".ql-strike", title: "删除线" },
        { Choice: ".ql-blockquote", title: "块引用" },
        { Choice: ".ql-code", title: "插入代码" },
        { Choice: ".ql-code-block", title: "插入代码段" },
        { Choice: ".ql-font", title: "字体" },
        { Choice: ".ql-size", title: "字体大小" },
        { Choice: '.ql-list[value="ordered"]', title: "编号列表" },
        { Choice: '.ql-list[value="bullet"]', title: "项目列表" },
        { Choice: '.ql-list[value="check"]', title: "项目头标" },
        { Choice: ".ql-direction", title: "文本方向" },
        { Choice: '.ql-header[value="1"]', title: "h1" },
        { Choice: '.ql-header[value="2"]', title: "h2" },
        { Choice: ".ql-align", title: "居左" },
        { Choice: '.ql-align[value="center"]', title: "居中" },
        { Choice: '.ql-align[value="right"]', title: "居右" },
        { Choice: '.ql-align[value="justify"]', title: "对齐" },
        { Choice: ".ql-color", title: "字体颜色" },
        { Choice: ".ql-background", title: "背景颜色" },
        { Choice: ".ql-image", title: "图像" },
        { Choice: ".ql-video", title: "视频" },
        { Choice: ".ql-link", title: "添加链接" },
        { Choice: ".ql-formula", title: "插入公式" },
        { Choice: ".ql-clean", title: "清除字体格式" },
        { Choice: '.ql-script[value="sub"]', title: "下标" },
        { Choice: '.ql-script[value="super"]', title: "上标" },
        { Choice: '.ql-indent[value="-1"]', title: "向左缩进" },
        { Choice: '.ql-indent[value="+1"]', title: "向右缩进" },
        { Choice: ".ql-header .ql-picker-label", title: "标题大小" },
        {
          Choice: '.ql-header .ql-picker-item[data-value="1"]',
          title: "标题一",
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="2"]',
          title: "标题二",
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="3"]',
          title: "标题三",
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="4"]',
          title: "标题四",
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="5"]',
          title: "标题五",
        },
        {
          Choice: '.ql-header .ql-picker-item[data-value="6"]',
          title: "标题六",
        },
        { Choice: ".ql-header .ql-picker-item:last-child", title: "标准" },
        {
          Choice: '.ql-size .ql-picker-item[data-value="small"]',
          title: "小号",
        },
        {
          Choice: '.ql-size .ql-picker-item[data-value="large"]',
          title: "大号",
        },
        {
          Choice: '.ql-size .ql-picker-item[data-value="huge"]',
          title: "超大号",
        },
        { Choice: ".ql-size .ql-picker-item:nth-child(2)", title: "标准" },
        { Choice: ".ql-align .ql-picker-item:first-child", title: "居左对齐" },
        {
          Choice: '.ql-align .ql-picker-item[data-value="center"]',
          title: "居中对齐",
        },
        {
          Choice: '.ql-align .ql-picker-item[data-value="right"]',
          title: "居右对齐",
        },
        {
          Choice: '.ql-align .ql-picker-item[data-value="justify"]',
          title: "两端对齐",
        },
      ];
      document.getElementsByClassName("vueql-editor")[0].dataset.placeholder =
        "";
      for (let item of titleConfig) {
        let tip = document.querySelector(".vueql-editor " + item.Choice);
        if (!tip) continue;
        tip.setAttribute("title", item.title);
      }
    },
    designRelease(i) {
      this.releaseIndex = i;
      this.arrIndex = [];
      this.releaseIndexTwo = null;
      if (this.releaseIndex == 0) {
        this.releasShow = true;
        this.twoNameRelease = this.releaseButton[1].button;
        this.form.demandType = "MODEL";
      } else {
        this.releasShow = false;
        this.twoNameRelease = this.releaseButton[0].button;
        this.form.demandType = "DESIGN";
        this.form.specificationsStart = null;
        this.form.specificationsEnd = null;
      }
      console.log("3333", this.form.demandType);
    },
    designReleaseTwo(items, i) {
      this.releaseIndexTwo = i;
      this.form.demandClassId = items;
    },
    designRelease2(i) {
      this.releaseIndex2 = i;
      let arrIndex = this.arrIndex.indexOf(i);
      if (arrIndex > -1) {
        // 已选中,点击取消
        this.arrIndex.splice(arrIndex, 1);
        this.form.fType.splice(arrIndex, 1);
      } else {
        // 未选中,点击选中
        this.arrIndex.push(i);
        this.form.fType.push(this.releaseButton2[this.releaseIndex][i].button);
      }
      // console.log("", this.form.fType);
    },
    // 其他
    designReleaseOther() {
      this.otherInput = !this.otherInput;
    },
    designRelease3(i) {
      this.releaseIndex3 = i;
      if (i == 0) {
        this.form.payType = "ONLINE";
      }
    },
    // 文件上传
    // 移除、点击 按钮 文件的信息
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    // 预览文件
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 限制文件的个数
    // handleExceed(files, fileList) {
    //   this.$message.warning(
    //     `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
    //       files.length + fileList.length
    //     } 个文件`
    //   );
    // },
    handleAvatarSuccess(obj, fileList) {
      console.log(obj);
      this.fileList.push(obj);
    },
    // 删除文件提示按钮
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    preAmount(rule, value, callback) {
      if (Number(this.form.lowPreAmount) > Number(this.form.highPreAmount)) {
        callback(new Error("预算最小值不可大于预算最大值"));
      } else {
        callback();
      }
    },
    deadDate(rule, value, callback) {
      if (this.form.expectedDeliveryTime < this.form.deadline) {
        callback(new Error("报名截止时间不能大于期望交期"));
      } else {
        callback();
      }
    },
    specifications(rule, value, callback) {
      if (
        Number(this.form.specificationsStart) >
        Number(this.form.specificationsEnd)
      ) {
        callback(new Error("尺寸规格最小值不能大于最大值"));
      } else {
        callback();
      }
    },
    // 发布需求
    open() {
      console.log("ddd", this.form);

      this.$refs.ruleForm.validate((valid, obj) => {
        if (!this.isLogin) {
          this.$confirm("请先登录再发布需求", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$router.push("/login");
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消发布需求",
              });
            });
        }else {
          if (valid) {
            this.$msgbox({
              title: "发布需求",
              message: "是否发布需求",
              showCancelButton: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  instance.confirmButtonLoading = true;
                  instance.confirmButtonText = "发布中...";
                  setTimeout(() => {
                    done();
                    setTimeout(() => {
                      instance.confirmButtonLoading = false;
                    }, 300);
                  }, 3000);
                } else {
                  done();
                }
              },
            }).then((action) => {
              let files = [];
              for (let i = 0; i < this.fileList.length; i++) {
                files.push({
                  fileUrl: this.fileList[i].url,
                  fileName: this.fileList[i].name,
                });
              }
              this.form.demandAttachments = files;
              console.log(this.form.demandAttachments);
              let fTypes = "";
              if (this.form.fType != null && this.form.fType.length > 0) {
                this.form.fType.forEach((item, index) => {
                  fTypes += item + "、";
                });
              }
              if (this.otherType != "") {
                fTypes = fTypes + this.otherType;
              } else if (
                this.otherType == "" &&
                this.form.fType != null &&
                this.form.fType.length > 0
              ) {
                fTypes = fTypes.substring(0, fTypes.length - 1);
              }
              this.form.fileType = fTypes;
              this.form.payType = "ONLINE";
              this.form.status = "AUDIT";
              console.log(this.form);
              addDemand(this.form).then((response) => {
                this.$message({
                  type: "success",
                  message: "发布成功",
                });
                this.loading = false;
                this.$router.push({
                  name: "sendSuccess",
                  params: { demandNo: response.data },
                });
              });
            });
          } else {
            for (let i in obj) {
              console.log("i", i);
              let refsMess = i;
              let dom = this.$refs[refsMess];
              dom.$el.scrollIntoView({
                //滚动到指定节点
                block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
                behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
              });
            }
          }
        }
      });
    },
    // 保存成功
    open2() {
      let files = [];
      if (!this.form.demandName) {
        this.$alert("请填写需求名称", "提示", {
          confirmButtonText: "确定",
        });
        return;
      } else {
        this.$confirm("是否保存需求", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        }).then(() => {
          if (this.isLogin) {
            for (let i = 0; i < this.fileList.length; i++) {
              files.push({
                fileUrl: this.fileList[i].url,
                fileName: this.fileList[i].name,
              });
            }
            this.form.demandAttachments = files;
            let fTypes = "";
            if (this.form.fType != null && this.form.fType.length > 0) {
              this.form.fType.forEach((item, index) => {
                fTypes += item + "、";
              });
            }
            if (this.otherType != "") {
              fTypes = fTypes + this.otherType;
            } else if (
                    this.otherType == "" &&
                    this.form.fType != null &&
                    this.form.fType.length > 0
            ) {
              fTypes = fTypes.substring(0, fTypes.length - 1);
            }
            this.form.fileType = fTypes;
            this.form.payType = "ONLINE";
            this.form.status = "DRAFT";
            console.log(this.form);
            addDemand(this.form).then((response) => {
              this.$confirm("需求保存成功，请前往买家中心发布需求", "提示", {
                confirmButtonText: "前往买家中心",
                cancelButtonText: "取消",
                type: "success",
              }).then(() => {
                // this.$router.push("/design");
                let routeData = this.$url.buyerMess;
                window.open(routeData, "_blank");
              });
              this.loading = false;
            });
          } else {
            this.$confirm("请先登录再保存需求", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
                    .then(() => {
                      this.$router.push("/login");
                    })
                    .catch(() => {
                      this.$message({
                        type: "info",
                        message: "取消保存需求",
                      });
                    });
          }
        })
                .catch(() => {});
      }

      this.loading = false;
    },
    //   返回
    open3() {
      this.$confirm("此操作将清空所有内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.form = [];
          this.$message({
            type: "success",
            message: "清除成功!",
          });
          this.$router.go(-1);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 获取字典值
    getDictionaryItem() {
      this.form.demandType = "MODEL";
      getDictionaryItem({ groupCode: "model" }).then((res) => {
        if (res != null && res.length > 0) {
          this.releaseButton[0].button = res[0].groupName;
          this.twoNameRelease = res[0].groupName;
          this.releaseButtonTwo.push(res);
        }
        getDictionaryItem({ groupCode: "design" }).then((res) => {
          if (res != null && res.length > 0) {
            this.releaseButton[1].button = res[0].groupName;
            this.releaseButtonTwo.push(res);
          }
        });
      });
    },
    // agreeChange(val) {
    //   this.form.lowPreAmount = "";
    //   this.form.highPreAmount = "";
    //   this.agreePrice = val;
    //   if (val == "NONE") {
    //     this.priceShow1 = false;
    //     this.priceShow2 = false;
    //   } else if (val == "FIXED") {
    //     this.priceShow1 = false;
    //     this.priceShow2 = true;
    //   } else if (val == "RANGE") {
    //     this.priceShow1 = true;
    //     this.priceShow2 = false;
    //   }
    // },
  },
};
</script>

<style scoped lang="less">
.release {
  width: 1200px;
  margin: 0 auto;
  // margin-bottom: 48px;
  .releaseNap {
    font-size: 14px;
    color: #808080;
    margin: 0 0 10px;
	display: flex;
	align-items: center;
  }
  .releaseBox {
    background: #fff;
    padding: 35px;
    box-sizing: border-box;
    .releaseBoxTop {
      margin-bottom: 15px;
      h4 {
        font-size: 18px;
        color: #157efa;
        margin-bottom: 18px;
      }
      .releaseBoxTopInput {
        font-size: 14px;
        color: #262626;
        align-items: center;
        margin-bottom: 20px;
        // /deep/.ql-toolbar.ql-snow {
        //   display: none;
        // }
        // /deep/.ql-toolbar.ql-snow + .ql-container.ql-snow {
        //   border-top: 1px solid #ccc;
        // }
        .releaseBoxTopInputBox {
          flex-wrap: wrap;
        }
        /deep/.ql-link {
          display: none;
        }
        input {
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          padding-left: 8px;
          box-sizing: border-box;
        }
        .input2 {
          width: 161px;
          // margin-left: 90px;
        }
        textarea {
          width: 100%;
          height: 206px;
          // background: #f5f5f5;
          opacity: 1;
          // border-radius: 6px;
          border: 1px solid #ccc;
          padding: 8px;
          box-sizing: border-box;
        }
        // /deep/.el-input--prefix .el-input__inner {
        //   width: 161px;
        //   height: 30px;
        //   background: #f5f5f5;
        //   border-radius: 4px;
        //   border: none;
        //   //   padding-left: 8px;
        //   box-sizing: border-box;
        //   //   margin-left: 25px;
        // }
        // /deep/.el-input__prefix {
        //   right: -132px;
        //   left: 0;
        // }
        /deep/.el-input__icon {
          line-height: 30px;
        }
        .releaseBoxbotInputP {
          width: 94px;
          flex-shrink: 0;
          white-space: nowrap;
          margin-bottom: 20px;
        }
        .releaseBut {
          background: #157efb;
          color: #fff;
        }
        button {
          width: 100px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          margin-right: 20px;
          color: #262626;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
    .releaseBoxBottom {
      font-size: 14px;
      margin: 0 auto;
      margin-top: 45px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        height: 31px;
        border-radius: 4px;
        color: #fff;
        border: none;
        cursor: pointer;
        line-height: 9px;

        &:nth-of-type(1) {
          width: 105px;
          background: linear-gradient(180deg, #4377fa 0%, #606aff 100%);
        }
        &:nth-of-type(2) {
          width: 105px;
          background: #157efb;
          margin: 0 20px;
        }
        &:nth-of-type(3) {
          width: 62px;
          background: #ebc71d;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/designRelease.vue